import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next'

import { useLazyQuery } from '@apollo/client';
import { GET_LOCATION_LIST } from 'graphql/common/queries';

export function LocationDropdown({ fields, other }) {
  const { t } = useTranslation()

  console.log('fields-fields--', fields)
  console.log('other-ddd--', other)

  const [boatLocationList, setBoatLocationList] = useState(null)

  const [getLocationList, { loading: locationListLoading, error: locationListError }] = useLazyQuery(GET_LOCATION_LIST, {
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    onCompleted: data => {
      if (data.searchLocation.locations.length > 0) {
        setBoatLocationList(data.searchLocation.locations)
      }
    },
  })

  // get Type List
  const getLocations = () => {
    getLocationList({
      variables: {
        searchLocationId: null,
        searchString: null,
        page: {
          limit: 100,
          offset: 0
        }

      },
    })
  }
  useEffect(() => {
    getLocations();
  }, []);

  return (
    <>
      {locationListLoading && <div className="flex justify-center items-center bg-white py-5">Loading ....</div>}
      {locationListError && (
        <div className="flex justify-center items-center bg-white py-5">
          <div className="text-lg text-center">{t('Failed to fetch locations')}</div>
        </div>
      )}
      {!locationListLoading && !locationListError && boatLocationList?.length === 0 && (
        <div className="flex justify-center items-center bg-white py-5">
          <div className="text-lg text-center">{t('No locations found!')}</div>
        </div>
      )}
      {!locationListLoading && !locationListError && boatLocationList?.length > 0 && (
        <select
          {...fields}
          disabled={fields.disabled}
          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:max-w-xs sm:text-sm sm:leading-6"
        >
          <option value="" label="Select a location" />
          {/* {purpose === 'filter' ? <option value={null}> {t('All')} </option> : <option value="" disabled> {t('Select Location')} </option>} */}
          {boatLocationList.map((location) => (
            <option key={location.id} value={location.id}>
              {location.name.en}
            </option>
          ))}
        </select>
      )}
    </>
  );
}

